const irJcamp = `
##TITLE=Benzoic acid, 3,5-dibromo-4-nitro-, ethyl ester
##JCAMP-DX=5.0
##DATA TYPE=LINK
##BLOCKS=1


$$ === CHEMSPECTRA SPECTRUM ORIG ===
##TITLE=Benzoic acid, 3,5-dibromo-4-nitro-, ethyl ester
##JCAMP-DX=5.00
##DATA TYPE=INFRARED SPECTRUM
##DATA CLASS=XYDATA
##ORIGIN=Sadtler Research Labs Under US-EPA Contract
##OWNER=NIST Standard Reference Data Program
##XUNITS=1/CM
##YUNITS=TRANSMITTANCE
##XFACTOR=1.0
##YFACTOR=0.000156284
##FIRSTX=3966.0
##LASTX=450.0
##MAXX=3966.0
##MAXY=1.56284
##MINX=450.0
##MINY=0.0
##NPOINTS=880
##XYDATA= (X++(Y..Y))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@E30
203B844E541G304H327H876I210I396I518I605I664I713I742I754I736I645I542
187I565I635I627I520I347I189I185I321I475I575I621I614I551I411I136H658
171H064G764H016H557I028I322I480I561I618I672I730I774I817I849I873I882
155I890I890I876I864I859I845I816I754I651I497I310I170I186I323I497I641
139I747I815I860I887I908I919I930I938I943I946I949I953I957I957I959I964
123I956I942I928I910I893I845I725I533I376I363I515I697I816I870I891I895
107I890I880I869I875I883I872I802I594I322I285I494I691I799I845I865I873
91I880I885I882I874I867I868I857I833I770I633I339H819H482H773I322I680
75I774I753I662I542I486I566I725I852I911I950I952I973I962I962I961I961
59I950I952I951I967I980I987I991I986I986I994I988I990I999I996I989I990
43I989I995I993I997I990I986I983I990I995I988I985I987I986I989I978I963
27I954I940I916I911I902I872I855I861I868I855I848I831I825I847I899I940
11I951I946I976I967I969I969I987I976I934I951I958
$$ === CHEMSPECTRA ===
##$OBSERVEDINTEGRALS= (X Y Z)
##$OBSERVEDMULTIPLETS=
##$OBSERVEDMULTIPLETSPEAKS=
##END=


$$ === CHEMSPECTRA PEAK TABLE EDIT ===
##TITLE=Benzoic acid, 3,5-dibromo-4-nitro-, ethyl ester
##JCAMP-DX=5.00
##DATA TYPE=INFRAREDPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSTHRESHOLD=0.93
##MAXX=3966.0
##MAXY=1.56284
##MINX=450.0
##MINY=0.0
##$CSSOLVENTNAME=- - -
##$CSSOLVENTVALUE=0
##$CSSOLVENTX=0
##NPOINTS=10
##PEAKTABLE= (XY..XY)
1022.0, 1.43312428
1126.0, 1.213388976
1170.0, 1.43546854
1266.0, 0.0
1366.0, 1.339666448
1378.0, 1.345292672
1562.0, 0.861437408
1750.0, 0.8306494600000001
##END=


$$ === CHEMSPECTRA PEAK TABLE AUTO ===
##TITLE=Benzoic acid, 3,5-dibromo-4-nitro-, ethyl ester
##JCAMP-DX=5.00
##DATA TYPE=INFRAREDPEAKTABLE
##DATA CLASS=PEAKTABLE
##$CSTHRESHOLD=0.93
##MAXX=3966.0
##MAXY=1.56284
##MINX=450.0
##MINY=0.0
##NPOINTS=10
##PEAKTABLE= (XY..XY)
1750.0, 0.83064946
1562.0, 0.861437408
1378.0, 1.345292672
1366.0, 1.339666448
1266.0, 0.0
1170.0, 1.43546854
1126.0, 1.213388976
1022.0, 1.43312428
838.0, 1.45109694
762.0, 1.3256008879999999
##END=

##END=

`;

export default irJcamp;
